import Uuid from "../../../../support/Uuid";
import DecimalForGlobals from "../../support/impuestos/DecimalForGlobals";

class ComprobantePagosInputPipe {

  getName() {
    return 'pagos';
  }

  apply(data, comprobante) {
    const cfdiUiid = data.Complemento?.TimbreFiscalDigital?.UUID;

    if (comprobante.isPago() && (data.TipoDeComprobante !== 'P' && data.MetodoPago !== 'PPD')) {
      throw new Error('El comprobante no tiene método de pago PPD (Pago en parcialidades o diferido)');
    }

    if (comprobante.isPago() && !!cfdiUiid) {
      delete data.CfdiRelacionados;

      if (data?.Complemento?.Pagos) {
        data.Complemento = {
          Pagos: {
            Totales: data.Complemento.Pagos.Totales,
            Pago: data.Complemento.Pagos.Pago.map((item) => {
              item.DoctoRelacionado = item.DoctoRelacionado.map((documento) => {

                if (documento.ImpuestosDR?.TrasladosDR?.TrasladoDR ?? null) {
                  documento.ImpuestosDR.TrasladosDR.TrasladoDR = documento.ImpuestosDR.TrasladosDR.TrasladoDR.map((impuesto) => {
                    return {
                      id: Uuid.v4(),
                      TasaOCuotaDR: impuesto.TipoFactorDR === 'Exento'
                        ? undefined
                        : DecimalForGlobals.make(impuesto.TasaOCuota).toString(6),
                      ...impuesto
                    }
                  });
                }

                if (documento.ImpuestosDR?.RetencionesDR?.RetencionDR ?? null) {
                  documento.ImpuestosDR.RetencionesDR.RetencionDR = documento.ImpuestosDR.RetencionesDR.RetencionDR.map((impuesto) => {
                    return {
                      id: Uuid.v4(),
                      TasaOCuotaDR: DecimalForGlobals.make(impuesto.TasaOCuota).toString(6),
                      ...impuesto
                    }
                  });
                }

                return {
                  id: Uuid.v4(),
                  ...documento,
                  EquivalenciaDR: !!documento.EquivalenciaDR
                    ? `${documento.EquivalenciaDR}`
                    : undefined,
                }
              });

              return {
                id: Uuid.v4(),
                ...item,
                TipoCambioP: !!item.TipoCambioP
                  ? `${item.TipoCambioP}`
                  : undefined,
              }
            })
          }
        }
      }
    }

    return data;
  }
}

export default ComprobantePagosInputPipe;